module.exports = __webpack_public_path__ + "static/media/ic_challenged_green.648c817a.svg";